exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-nowrap[data-v-d5cae5ac]{text-wrap:nowrap}\n", ""]);

// exports
